export default "__VITE_ASSET__DvfN8lDB__"